export default __webpack_public_path__ + "c82125e3cb7ae07445fa7d5cf3d5d679.png";